import ApiRoutes from "../../../constants/api-routes";
import { hneAdminApi } from "../../../service";

export const imageUpload = async (body) =>
  hneAdminApi.post(`${ApiRoutes.UPLOAD_IMAGE}`, body);
